import { getKeys, PartialRecord } from "@base/util/TypeUtil";
import { ArticleFeatureConfig, ArticleFeatureStore, IArticleFeatureTemplate } from "@biz/definitions/ArticleFeatureDefinitions";
import { articleFeatureHandlers, IShopFeatureTemplateId, shopTemplates } from "@biz/definitions/ArticleShopTemplates";

const articleFeatureMap: Record<string, {
  shopFeatureTemplate?: IArticleFeatureTemplate;
  features?: ArticleFeatureConfig;
}> = {
  "00E13001419": { // Winkelleiste
    shopFeatureTemplate: {
      length: { mul: true, ...articleFeatureHandlers.lengthInM, values: { type: "minMax", min: 2, max: 4, step: 1 } },
    }
  },
  "00E13000107": {  // Pylonseil
    shopFeatureTemplate: {
      length: { mul: true, ...articleFeatureHandlers.lengthInM, values: { type: "slider", min: 3, max: 50, step: 1, decimals: 0 }, defaultValue: 10, }
    }
  },

  "00E13001026": { shopFeatureTemplate: shopTemplates.prallSchutz, features: { colorId: "red", length: 1 } },
  "00E13001027": { shopFeatureTemplate: shopTemplates.prallSchutz, features: { colorId: "red", length: 1.5 } },
  "00E13001084": { shopFeatureTemplate: shopTemplates.prallSchutz, features: { colorId: "blue", length: 1 } },
  "00E13001085": { shopFeatureTemplate: shopTemplates.prallSchutz, features: { colorId: "blue", length: 1.5 } },
  "00E13001086": { shopFeatureTemplate: shopTemplates.prallSchutz, features: { colorId: "yellow", length: 1 } },
  "00E13001087": { shopFeatureTemplate: shopTemplates.prallSchutz, features: { colorId: "yellow", length: 1.5 } },

  "00E13000062": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "grey", diameter: 4 } },
  "00E13000023": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "grey", diameter: 6.5 } },
  "00E13001359": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "grey", diameter: 8 } },
  "00E13000083": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "grey", diameter: 10 } },
  "00E13001346": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "blue", diameter: 6.5 } },
  "00E13001352": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "blue", diameter: 8 } },
  "00E13001347": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "orange", diameter: 6.5 } },
  "00E13001353": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "orange", diameter: 8 } },
  "00E13001351": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "green", diameter: 6.5 } },
  "00E13001357": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "green", diameter: 8 } },
  "00E13001348": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "red", diameter: 6.5 } },
  "00E13001354": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "red", diameter: 8 } },
  "00E13001349": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "purple", diameter: 6.5 } },
  "00E13001355": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "purple", diameter: 8 } },
  "00E13001350": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "navy", diameter: 6.5 } },
  "00E13001356": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "navy", diameter: 8 } },
  "00E13002048": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "black", diameter: 6.5 } },
  "00E13002063": { shopFeatureTemplate: shopTemplates.spannSeil, features: { colorId: "black", diameter: 8 } },

  "00E13001406": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "grey", diameter: 6.5, priceTag: "I" } }, // Enthalten
  "00E13001392": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "blue", diameter: 6.5, priceTag: "I" } }, // Enthalten
  "00E13001393": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "navy", diameter: 6.5 , priceTag: "I"} }, // Enthalten
  "00E13001394": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "purple", diameter: 6.5, priceTag: "I" } }, // Enthalten
  "00E13001395": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "orange", diameter: 6.5, priceTag: "I" } }, // Enthalten
  "00E13001396": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "red", diameter: 6.5, priceTag: "I" } }, // Enthalten
  "00E13001397": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "green", diameter: 6.5, priceTag: "I" } }, // Enthalten
  "00E13002071": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "black", diameter: 6.5, priceTag: "I" } }, // Enthalten

  "00E13001404": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "grey", diameter: 8, priceTag: "I" } }, // Enthalten
  "00E13001398": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "blue", diameter: 8 , priceTag: "I"} }, // Enthalten
  "00E13001399": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "navy", diameter: 8, priceTag: "I" } }, // Enthalten
  "00E13001400": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "purple", diameter: 8, priceTag: "I" } }, // Enthalten
  "00E13001401": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "orange", diameter: 8, priceTag: "I" } }, // Enthalten
  "00E13001402": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "red", diameter: 8, priceTag: "I" } }, // Enthalten
  "00E13001403": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "green", diameter: 8, priceTag: "I" } }, // Enthalten
  "00E13002072": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "black", diameter: 8 , priceTag: "I"} }, // Enthalten

  "00E13001407": { shopFeatureTemplate: shopTemplates.spannSeilSpecial, features: { colorId: "grey", diameter: 8, priceTag: "A" } }, // Aufpreis
  "00E13001360": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "blue", diameter: 8, priceTag: "A" } }, // Aufpreis
  "00E13001361": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "navy", diameter: 8, priceTag: "A" } }, // Aufpreis
  "00E13001362": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "purple", diameter: 8, priceTag: "A" } }, // Aufpreis
  "00E13001363": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "orange", diameter: 8, priceTag: "A" } }, // Aufpreis
  "00E13001364": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "red", diameter: 8 , priceTag: "A" } }, // Aufpreis
  "00E13001365": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "green", diameter: 8 , priceTag: "A"} }, // Aufpreis
  "00E13002073": { shopFeatureTemplate: shopTemplates.spannSeilSpecial,features: { colorId: "black", diameter: 8 , priceTag: "A"} }, // Aufpreis


  "71004A010": { shopFeatureTemplate: shopTemplates.protectiveCoverStandard, features: { sst: ["C", "X", "XS"], quality: "standard", colorId: "935653" } },
  "71004A011": { shopFeatureTemplate: shopTemplates.protectiveCoverStandard, features: { sst: ["C", "X", "XS"], quality: "premium", colorId: "935653" } },
  "71004A012": { shopFeatureTemplate: shopTemplates.protectiveCoverSpecial, features: { sst: ["C", "X", "XS"], quality: "standard" } },
  "71004A013": { shopFeatureTemplate: shopTemplates.protectiveCoverSpecial, features: { sst: ["C", "X", "XS"], quality: "premium" } },
  "73004A001": { shopFeatureTemplate: shopTemplates.protectiveCoverStandard, features: { sst: ["MA", "M", "CS"], quality: "standard", colorId: "935653" } },
  "70004A007": { shopFeatureTemplate: shopTemplates.protectiveCoverStandard, features: { sst: ["MA", "M", "CS"], quality: "premium", colorId: "935653", } },
  "73004A002": { shopFeatureTemplate: shopTemplates.protectiveCoverSpecial, features: { sst: ["MA", "M", "CS"], quality: "standard" } },
  "70004A008": { shopFeatureTemplate: shopTemplates.protectiveCoverSpecial, features: { sst: ["MA", "M", "CS"], quality: "premium" } },

  "71004A003": { shopFeatureTemplate: shopTemplates.cornerProtection, features: { colorId: "935653" } },
  "71004A004": { shopFeatureTemplate: shopTemplates.cornerProtection, features: {} },
  "71004A005": { shopFeatureTemplate: shopTemplates.cornerProtection, features: { colorId: "935653" } },
  "71004A006": { shopFeatureTemplate: shopTemplates.cornerProtection, features: {} },
  "71004A020": { shopFeatureTemplate: shopTemplates.cornerProtection, features: {} },
  "71004A021": { shopFeatureTemplate: shopTemplates.cornerProtection, features: { colorId: "935653" } },

  "00E13000255": { shopFeatureTemplate: shopTemplates.drahtSeil, features: { diameter: 3 } },
  "00E13000067": { shopFeatureTemplate: shopTemplates.drahtSeil, features: { diameter: 4 } },

  "00E13000803": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 2, colorId: "grey" } },
  "00E13000082": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 3, colorId: "grey" } },
  "00E13000145": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 4, colorId: "grey" } },
  "00E13000146": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 5, colorId: "grey" } },
  "00E13000423": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 6, colorId: "grey" } },
  "00E13000421": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 7, colorId: "grey" } },
  "00E13000422": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 8, colorId: "grey" } },

  "00E13002052": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 2, colorId: "black" } },
  "00E13002049": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 3, colorId: "black" } },
  "00E13002050": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 4, colorId: "black" } },
  "00E13002051": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 5, colorId: "black" } },
  "00E13002053": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 6, colorId: "black" } },
  "00E13002054": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 7, colorId: "black" } },
  "00E13002055": { shopFeatureTemplate: shopTemplates.umlaufSeil, features: { length: 8, colorId: "black" } },

  "00E13000282": { shopFeatureTemplate: shopTemplates.kederSchiene, features: { diameterId: "7.5" }, },
  "00E13000684": { shopFeatureTemplate: shopTemplates.kederSchiene, features: { diameterId: "10-13" } },

  "00E13001326": { shopFeatureTemplate: shopTemplates.algaeRemover, features: { volume: 500 } },
  "00E13001252": { shopFeatureTemplate: shopTemplates.algaeRemover, features: { volume: 1000 } },

  "00E13000093": { shopFeatureTemplate: shopTemplates.rubberRope, features: { colorId: "black", diameter: 6 } },
  // "00E13001029": { shopFeatureTemplate: shopTemplates.rubberRope, features: { colorId: "black", diameter: 6 } }, // momentan noch nicht exportiert https://plaspack.atlassian.net/browse/OA-13
  "00E13000784": { shopFeatureTemplate: shopTemplates.rubberRope, features: { colorId: "white", diameter: 8 } },
  "00E13000785": { shopFeatureTemplate: shopTemplates.rubberRope, features: { colorId: "red", diameter: 8 } },
  "00E13000786": { shopFeatureTemplate: shopTemplates.rubberRope, features: { colorId: "blue", diameter: 8 } },
  "00E13000787": { shopFeatureTemplate: shopTemplates.rubberRope, features: { colorId: "black", diameter: 8 } },

  "00E13000012": { shopFeatureTemplate: shopTemplates.spannFlex, features: { colorId: "black" } },
  "00E13001019": { shopFeatureTemplate: shopTemplates.spannFlex, features: { colorId: "white" } },
  "00E13000016": { shopFeatureTemplate: shopTemplates.spannQuick, features: { colorId: "black" } },
  "00E13000258": { shopFeatureTemplate: shopTemplates.spannQuick, features: { colorId: "white" } },

  "00710A002": { shopFeatureTemplate: shopTemplates.clipOnMini, features: { colorId: "black" } },
  "00710A003": { shopFeatureTemplate: shopTemplates.clipOnMini, features: { colorId: "white" } },
  "00710A004": { shopFeatureTemplate: shopTemplates.clipOnMidi, features: { colorId: "black" } },
  "00710A005": { shopFeatureTemplate: shopTemplates.clipOnMidi, features: { colorId: "white" } },

  "00E13000816": { shopFeatureTemplate: shopTemplates.ropeConserver, features: { volume: 100 } },
  "00E13001405": { shopFeatureTemplate: shopTemplates.ropeConserver, features: { volume: 500 } },

  "00E13000850": { shopFeatureTemplate: shopTemplates.motorCable, features: { length: 2, colorId: "white" } },
  "00E13000374": { shopFeatureTemplate: shopTemplates.motorCable, features: { length: 5, colorId: "white" } },
  "00E13001091": { shopFeatureTemplate: shopTemplates.motorCable, features: { length: 10, colorId: "white" } },
  "00E13001901": { shopFeatureTemplate: shopTemplates.motorCable, features: { length: 2, colorId: "black" } },
  "00E13001902": { shopFeatureTemplate: shopTemplates.motorCable, features: { length: 5, colorId: "black" } },
  "00E13001903": { shopFeatureTemplate: shopTemplates.motorCable, features: { length: 10, colorId: "black" } },
}

const articleToShopGroup: Record<string, IShopFeatureTemplateId> = {}
const articleFeatureGroups: PartialRecord<IShopFeatureTemplateId, { shopArticles: string[]; _featureTemplate: IArticleFeatureTemplate; }> = {}

for (const o of Object.keys(articleFeatureMap)) {
  const item = articleFeatureMap[o];
  if (item.shopFeatureTemplate) {
    const groupId = getKeys(shopTemplates).find((k) => shopTemplates[k] === item.shopFeatureTemplate)
    if (groupId) {
      if (articleFeatureGroups[groupId] === undefined)
        articleFeatureGroups[groupId] = { shopArticles: [], _featureTemplate: item.shopFeatureTemplate };
      articleFeatureGroups[groupId].shopArticles.push(o);
      articleToShopGroup[o] = groupId;
    }
  }
}


export class ArticleFeatureMap {
  static isArticleNew(articleNumber: string): boolean {
    return /*access >= Access.FluchtpunktAdmin && */(!!articleFeatureMap[articleNumber] || !!articleFeatureGroups[articleNumber as IShopFeatureTemplateId]);
  }

  static #featureConfigToFeatureStore(featureConfig: ArticleFeatureConfig | undefined): ArticleFeatureStore {
    const featureStore: ArticleFeatureStore = {};
    if (!featureConfig)
      return featureStore;

    for (const k of getKeys(featureConfig)) {
      if (featureStore[k] === undefined) {
        const afk = featureConfig[k];
        featureStore[k] = (Array.isArray(afk) ? afk[0] : afk) as any;
      }
    }
    return featureStore;
  }

  static getArticleFeatureConfig(articleNumber: string): ArticleFeatureConfig | undefined {
    const featureConfig = articleFeatureMap[articleNumber]?.features;
    return featureConfig;
  }

  static getInitialArticleFeatures(articleNumber: string): ArticleFeatureStore | undefined {
    const featureConfig = articleFeatureMap[articleNumber]?.features;
    return this.#featureConfigToFeatureStore(featureConfig);
  }

  static getShopFeatureTemplate(articleNumber: string): IArticleFeatureTemplate | undefined {
    const featureTemplate = articleFeatureMap[articleNumber]?.shopFeatureTemplate;
    if (!featureTemplate) {
      if (articleFeatureGroups[articleNumber as IShopFeatureTemplateId]?._featureTemplate) {
        return articleFeatureGroups[articleNumber as IShopFeatureTemplateId]?._featureTemplate;
      }
    }
    return featureTemplate;
  }

  static getShopArticleGroupId(articleNumber: string): string | undefined {
    return articleToShopGroup[articleNumber];
  }

  static getShopFeatureArticles(shopArticleGroupId: IShopFeatureTemplateId): string[] {
    return articleFeatureGroups[shopArticleGroupId]?.shopArticles || [];
  }
}